import React from "react";
import { Link } from "react-router-dom";

function RightSection({
  imageURL,
  productName,
  productDescription,
  learnMore,
}) {
  return (
    <div className="container mt-5">
      <div className="row">

        <div className="col-6 p-5 mt-5">
          <h1>{productName}</h1>
          <p>{productDescription}</p>

          <div>
            <Link to={learnMore}>
              Learn More{" "}
              <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

        <div className="col-6">
          <img src={imageURL} alt={productName} />
        </div>

      </div>
    </div>
  );
}

export default RightSection;